module.exports = __webpack_public_path__ + "img/default.072e8dbf.png";